import { Pipe, PipeTransform } from '@angular/core';
import { PermissionsService } from '../../lib/services/permissions.service';
import { map, Observable } from 'rxjs';
import { BackgroundEntity, Entity } from '@ag-common-lib/lib/lists/entity-permission.enum';
import { EntityPermissionActivityKeys } from '@ag-common-lib/public-api';

@Pipe({
  name: 'hasPermission',
})
export class HasPermissionPipe implements PipeTransform {
  constructor(private permissionsService: PermissionsService) {}

  transform(
    entity: keyof typeof Entity | keyof typeof BackgroundEntity,
    entityPermissionKey?: EntityPermissionActivityKeys | EntityPermissionActivityKeys[],
  ): Observable<boolean> {
    return this.permissionsService?.permissions$?.pipe(
      map(permission => {
        const permissionState = permission?.[entity];
        if (!permissionState) {
          return false;
        }
        if (entityPermissionKey && entityPermissionKey?.length) {
          const keysToCheck = Array.isArray(entityPermissionKey) ? entityPermissionKey : [entityPermissionKey];
          const hasPermissions = keysToCheck.some(key => !!permissionState?.[key]);

          return hasPermissions;
        }

        return Object.values(EntityPermissionActivityKeys).some(key => permissionState[key]);
      }),
    );
  }
}
